import { callApi } from '@local_modules/generic/fetch.js'
import { fillString } from '@local_modules/generic/string-template.js'
import { setElementHtml } from '../../../../helpers/generic-js/dom.js'

/**
 *
 * @param {*} inviteId
 */
export async function acceptInvite (inviteData) {
  const apiUrl = '/api/user-invites/accept/:inviteId'

  const data = await callApi(apiUrl, {
    inviteId: inviteData.id
  }, {
    method: 'PUT'
  })

  if (!data) {
    setElementHtml('feedback', 'The invitation could not be accepted.')
    return
  }

  redirectToAppAccount(inviteData)
}

function redirectToAppAccount (inviteData) {
  const redirectUrl = fillString('/app/a/:appAccountId/manage-entities', {
    appAccountId: inviteData.app_account_id
  })

  location.href = redirectUrl
}
